"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetGamepadsInOrder = void 0;
const gamepadEvents_1 = require("../../core/gamepadEvents");
const foundation_1 = require("../../core/foundation");
const react_1 = require("react");
/**
 * @returns a list of gamepad ids in the order they were last interacted with
 *
 * Note: polled gamepad uses index (number) while injected gamepad uses actual gamepad id (string)
 */
const useGetGamepadsInOrder = () => {
    const [gamepadsInOrder, setGamepadsInOrder] = (0, react_1.useState)((0, foundation_1.getGamepadsInOrder)());
    (0, react_1.useEffect)(() => {
        gamepadEvents_1.GamepadEventEmitter.addListener(gamepadEvents_1.MostRecentGamepad.Change, setGamepadsInOrder);
        return () => {
            gamepadEvents_1.GamepadEventEmitter.removeListener(gamepadEvents_1.MostRecentGamepad.Change, setGamepadsInOrder);
        };
    }, []);
    return gamepadsInOrder;
};
exports.useGetGamepadsInOrder = useGetGamepadsInOrder;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlR2V0R2FtZXBhZHNJbk9yZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2hvb2tzL3V0aWxpdHkvdXNlR2V0R2FtZXBhZHNJbk9yZGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSw0REFBNEQ7OztBQUU1RCw0REFBa0Y7QUFFbEYsc0RBQTJEO0FBQzNELGlDQUE0QztBQUU1Qzs7OztHQUlHO0FBQ0ksTUFBTSxxQkFBcUIsR0FBRyxHQUFnQixFQUFFO0lBQ25ELE1BQU0sQ0FBQyxlQUFlLEVBQUUsa0JBQWtCLENBQUMsR0FBRyxJQUFBLGdCQUFRLEVBQUMsSUFBQSwrQkFBa0IsR0FBRSxDQUFDLENBQUM7SUFFN0UsSUFBQSxpQkFBUyxFQUFDLEdBQUcsRUFBRTtRQUNYLG1DQUFtQixDQUFDLFdBQVcsQ0FBQyxpQ0FBaUIsQ0FBQyxNQUFNLEVBQUUsa0JBQWtCLENBQUMsQ0FBQztRQUU5RSxPQUFPLEdBQUcsRUFBRTtZQUNSLG1DQUFtQixDQUFDLGNBQWMsQ0FBQyxpQ0FBaUIsQ0FBQyxNQUFNLEVBQUUsa0JBQWtCLENBQUMsQ0FBQztRQUNyRixDQUFDLENBQUM7SUFDTixDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFFUCxPQUFPLGVBQWUsQ0FBQztBQUMzQixDQUFDLENBQUM7QUFaVyxRQUFBLHFCQUFxQix5QkFZaEMifQ==